/**
 * It is a list of items within a container on a page
 *
 * @module views/components/TitleCompact
 * @memberof -Common
 */
import './TitleCompact.scss';

import React from 'react';

import PropTypes from 'prop-types';

import Text from '@ulta/core/components/Text/Text';

import Divider from '../Divider/Divider';

/**
 * Represents a TitleCompact component
 *
 * @method
 * @param {TitleCompactProps} props - React properties passed from composition
 * @returns TitleCompact
 */
export const TitleCompact = function( props ){
  const { htmlTag = defaultProps.htmlTag } = props;
  return (
    <div className='TitleCompact'>
      <div className='TitleCompact__TitleDisplay'>
        <Text htmlTag={ htmlTag }>{ props.title }</Text>
        <div className='TitleCompact__SubTitle'>
          { props.subTitle && (
            <Text htmlTag='span'
              textStyle='body-3'
              color='neutral-600'
            >
              { props.subTitle }
            </Text>
          ) }
        </div>
      </div>
      { props.showDivider && (
        <Divider type={ 'gray' }>
          { ' ' }
        </Divider>
      ) }
    </div>
  );
};

/**
 * Property type definitions
 * @typedef TitleCompactProps
 * @type {object}
 * @property {string} title - sets the title
 * @property {string} subTitle - sets the sub title
 * @property {string} showDivider - boolean for show/hide the divider
 * @property {string} htmlTag - Sets the html tag for TitleCompact
 */
export const propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  showDivider: PropTypes.bool,
  htmlTag: PropTypes.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} htmlTag: By default title tag is h1
 */

export const defaultProps = {
  htmlTag: 'h1'
};

TitleCompact.propTypes = propTypes;
TitleCompact.defaultProps = defaultProps;

export default TitleCompact;
